// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import { LOGIN } from '../constants/paths';

const PrivateRoute = ({ children }) => {
    const { token } = useAuth();
    
    return token ? (
      children
    ) : (
      <Navigate to={LOGIN} replace />
    );
  };

export default PrivateRoute;
